import { connect } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import ResultsFooter, { OwnProps, StateProps } from 'components/global/application/results_footer/ResultsFooter';

const mapStateToProps = (state: IRootState): StateProps => {
    const { currentPage, lastPage, perPage, total  } = state.brandInfo.brandPager;
    return {
        currentPage,
        numPages: lastPage,
        numResults: total,
        viewNumber: perPage
    };
};

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(ResultsFooter);



// WEBPACK FOOTER //
// ./src/containers/pages/brand/BrandInfoPager.tsx